<template>
	<div class="order-list-content-page">
		<template v-if="orderData && orderData.total > 0">
			<div class="order-content" v-for="item in orderData.records" :key="item.id">
				<div class="left-box">
					<div class="order-msg">
						<div class="order-time">下单时间：{{ item.createTime }}</div>
						<div class="order-no">订单编号：{{ item.orderSn }}</div>
					</div>
					<div class="good-msg">
						<div class="good-content">
							<div class="img-box" v-for="(img, index) in item.productPic" :key="index" v-if="index < 5">
								<img :src="img" />
							</div>
						</div>
						<div class="total-box">
							<div class="num">共<span>{{ item.productPic.length }}</span>种商品</div>
							<div class="price">￥{{ item.userAmount }}</div>
						</div>
						<div class="status-box">
							<div class="status"
								:class="{ 'status-cancel': item.status == '601' || item.status == '701' }">
								{{ getStatus(item.status) }}</div>
							<div class="detail-btn" @click="handleDetails(item)">订单详情</div>
						</div>
					</div>
				</div>
				<div class="right-box">
					<div class="count-down" v-if="item.status == '000'">{{ getPayCountDown(item) }}</div>
					<template v-if="item.status == '000' || item.status == '301'">
						<el-button type="primary" v-if="item.status == '000'" @click="doPay(item.id);">付款</el-button>
						<el-button type="primary" v-else-if="item.status == '301'" @click="confirmReceipt(item.id);">确认收货</el-button>
					</template>
					<el-button type="info" plain v-if="item.status == '000'" @click="cancelOrder(item.id);">取消订单</el-button>
					<el-button type="info" plain v-else @click="againOrder(item.id);">再来一单</el-button>
				</div>
			</div>
			<el-pagination @current-change="handleCurrentChange" :current-page.sync="current" :page-size="size"
				layout="prev, pager, next, jumper" :total="orderData.total">
			</el-pagination>
		</template>
		<el-empty v-else description="暂无订单"></el-empty>
		
		<!-- 支付成功弹窗 -->
		<successPop :sucessPopShow="dialogVisibleSucess" :userAmount="parseFloat(payInfo.userAmount)"
			@handleLimit="handleLimit" @handleSucessShow="handleLimit">
		</successPop>
		
		<!-- 支付失败弹窗 -->
		<el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :before-close="handleLimitWarning">
			<div class="warning-box">
				<div class="warning-list">
					<div class="li">
						当前{{payInfo.payType == 'PAYMENT' ? '余额' :'授信额度'}}不足
					</div>
					<template v-if="payInfo.payType == 'PAYMENT'">
						<div class="li" v-if="payInfo.balance">
							当前余额： ￥{{parseFloat(payInfo.balance)}}
						</div>
						<div class="li" v-if="payInfo.userAmount">
							支付金额： ￥{{parseFloat(payInfo.userAmount)}}
						</div>
						<div class="li" v-if="payInfo.balance && payInfo.userAmount">
							请再充值： ￥{{Math.abs(payInfo.balance - payInfo.userAmount)}} 订单72小时有效
						</div>
					</template>
					<template v-if="payInfo.payType == 'CREDIT'">
						订单72小时有效
					</template>
				</div>
				<div class="btn" @click.stop="handleLimitWarning">
					确认
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getOrderList,
		cancelOrder,
		doPayOrder,
		confirmReceipt,
		againOrder
	} from '@/api/order.js';
	import successPop from '@/components/successPop'
	var cancelOrderId = null;
	var confirmOrderId = null;
	var paySuccessOrderId = null;

	export default {
		name: 'order-content',
		components: {
			successPop
		},
		props: {
			status: {
				type: String,
				default: ''
			},
			tabName: {
				type: String,
				default: 'all'
			}
		},
		watch: {
			tabName: {
				handler(val) {
					if (((this.status == '' && val == 'all') || this.status == val) && !this.orderData.total) {
						this.$emit('loading', true);
						this.getOrderList();
					}
					 // 改变 全部订单页签 里订单状态
					if((this.status == '' && val == 'all') && this.orderData.records && this.orderData.records.length > 0) {
						//  取消订单后 改变 全部订单页签里订单状态
						if(cancelOrderId && cancelOrderId !== null) {
							this.orderData.records.forEach((item, cancelIndex) => {
								if (item.id === cancelOrderId) {
									item.status = '701';
								}
							})
						}
						
						// 确认收货后 改变 全部订单页签里订单状态	
						if(confirmOrderId && confirmOrderId !== null) {
							this.orderData.records.forEach((item, confirmIndex) => {
								if (item.id === confirmOrderId) {
									item.status = '501';
								}
							})
						}
						
						// 支付成功 后 改变全部订单页签里订单状态 
						if(paySuccessOrderId && paySuccessOrderId !== null) {
							this.orderData.records.forEach((item, paySuccessIndex) => {
								if (item.id === paySuccessOrderId) {
									item.status = '101';
								}
							})
						}
					}
					
					// 改变 待付款页签 里订单状态
					if((this.status == '000') && this.orderData.records && this.orderData.records.length > 0) {
						//  取消订单后 改变 待付款页签里订单状态
						if(cancelOrderId && cancelOrderId !== null) {
							this.orderData.records.forEach((item, cancelIndex) => {
								if (item.id === cancelOrderId) {
									this.$emit('loading', true);
									this.getOrderList();
								}
							})
						}
						
						
						// 支付成功 后 改变待付款页签里订单状态 
						if(paySuccessOrderId && paySuccessOrderId !== null) {
							this.orderData.records.forEach((item, paySuccessIndex) => {
								if (item.id === paySuccessOrderId) {
									this.$emit('loading', true);
									this.getOrderList();
								}
							})
						}
					}
					
					//  确认收货后 已发货 页签 里删除这笔订单
					if(this.status == '301' && this.orderData.records && this.orderData.records.length > 0) {
						if(confirmOrderId && confirmOrderId !== null) {
							this.$emit('loading', true);
							this.getOrderList();
						}
					}
					
					//  确认收货后 已收货 页签 里追加这笔订单（刷新接口）
					if(this.status == '501' && this.orderData.records && this.orderData.records.length > 0) {
						if(confirmOrderId && confirmOrderId !== null) {
							this.$emit('loading', true);
							this.getOrderList();
						}
					}
				},
				immediate: true
			}
		},
		destroyed() {
			cancelOrderId = null;
			confirmOrderId = null;
			paySuccessOrderId = null;
		},
		data() {
			return {
				orderData: {},
				current: 1,
				size: 10,
				payInfo: '', //支付的金额明细
				dialogVisibleSucess: false, // 是否显示支付成功弹窗
				dialogVisible: false, // 是否显示支付成功弹窗
			};
		},
		methods: {
			// 支付成功关闭弹窗刷新接口
			handleLimit() {
				this.dialogVisibleSucess = false;
				this.getOrderList();
				this.$emit('refreshGroupOrder');
			},
			// 支付失败关闭弹窗
			handleLimitWarning() {
				this.dialogVisible = false;
			},
			/**
			 * 2023-02-09 董浩
			 * 获取订单列表
			 * */
			getOrderList() {
				let params = {
					current: this.current,
					size: this.size
				};

				if (this.status) {
					params.status = this.status;
				}

				getOrderList(params).then(res => {
					this.$emit('loading', false);

					if (res && res.code == '0') {
						this.orderData = res.data;
					} else {
						this.$message.error(res && res.msg ? res.msg : '数据加载失败');
					}
				});
			},

			/**
			 * 2023-02-09 董浩
			 * 页码改变加载数据
			 * */
			handleCurrentChange(val) {
				this.$emit('loading', true);
				this.getOrderList();
			},

			/**
			 * 2023-02-09 董浩
			 * 获取状态
			 * WAITINF_FOR_PAYMENT("000", "待付款"),
			 * WAITINF_FOR_DELIVERY("101", "待发货"),
			 * DELIVERED("301", "已发货"),
			 * COMPLETION("501", "已收货"),
			 * CLOSED("601", "交易关闭"),
			 * CANCELED("701", "已取消"),
			 * */
			getStatus(status) {
				if (status == '000') {
					return '待付款';
				} else if (status == '101') {
					return '待发货';
				} else if (status == '301') {
					return '已发货';
				} else if (status == '501') {
					return '已收货';
				} else if (status == '601') {
					return '交易关闭';
				} else if (status == '701') {
					return '已取消';
				}
			},

			/**
			 * 2023-02-09 董浩
			 * 获取状态
			 * */
			getPayCountDown(item) {
				let date = (72 * 3600 * 1000) - (new Date().getTime() - new Date(item.createTime).getTime());

				if (date <= 0) {
					return '';
				}
				
				let leave1 = date % (24 * 3600 * 1000);
				let hours = Math.floor(date / (3600 * 1000));

				//计算相差分钟数
				let leave2 = leave1 % (3600 * 1000);
				let minutes = Math.floor(leave2 / (60 * 1000));

				if (hours > 0) {
					return '剩' + hours + '小时' + minutes + '分钟';
				}
				else if (minutes > 0) {
					return '剩' + minutes + '分钟';
				}
				else {
					return '';
				}
			},
			
			/**
			 * 2023-02-09 董浩
			 * 确认收货
			 * */
			confirmReceipt(id) {
				this.$confirm('是否已收到货品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$emit('loading', true);
					confirmReceipt({
						orderId: id
					}).then(res => {
						if (res && res.code == '0') {
							this.getOrderList();
							this.$message.success('已成功确认收货');
							this.$emit('refreshGroupOrder');
							confirmOrderId = id;
						} else {
							this.$emit('loading', false);
							this.$message.error(res && res.msg ? res.msg : '取消失败');
						}
					});
				});
			},
			
			/**
			 * 2023-02-09 董浩
			 * 付款
			 * */
			doPay(id) {
				this.$emit('loading', true);
				doPayOrder({
					orderId: id
				}).then(res => {
					if (res && res.code == '0') {
						if(res.data) {
							this.payInfo = res.data;
							this.dialogVisibleSucess = true;
							paySuccessOrderId = id;
						} else {
							this.getOrderList();
							this.$message.success('支付成功');
							this.$emit('refreshGroupOrder');
							paySuccessOrderId = id;
						}

					} else {
						this.$emit('loading', false);
						if(res.data) {
							this.payInfo = res.data;
							this.dialogVisible = true;
						} else {
							this.$message.error(res && res.msg ? res.msg : '取消失败');
						}
					}
				});
			},
			
			/**
			 * 2023-02-09 董浩
			 * 再来一单
			 * */
			againOrder(id) {
				this.$emit('loading', true);
				againOrder({
					orderId: id
				}).then(res => {
					this.$emit('loading', false);
					
					if (res && res.code == '0') {
						this.$confirm('已添加购物车，是否前往下单？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$router.push('/cart');
						});
					} else {
						this.$message.error(res && res.msg ? res.msg : '取消失败');
					}
				});
			},
			
			/**
			 * 2023-02-09 董浩
			 * 取消订单
			 * */
			cancelOrder(id) {
				this.$confirm('确认取消订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$emit('loading', true);
					cancelOrder({
						orderId: id
					}).then(res => {
						if (res && res.code == '0') {
							this.getOrderList();
							this.$message.success('取消成功');
							this.$emit('refreshGroupOrder');
							cancelOrderId = id;
						} else {
							this.$emit('loading', false);
							this.$message.error(res && res.msg ? res.msg : '取消失败');
						}
					});
				});
			},
			/**
			 * 2023-02-13 刘美玉
			 * 跳转订单详情
			 * */
			handleDetails(data) {
				this.$router.push('/orderDetails?orderId=' + data.id);
			}
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.order-list-content-page {
		.order-content {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
			height: 153px;
			background: #FFFFFF;
			border-radius: 8px;

			.left-box {
				flex: 1;
				padding: 20px 20px 15px;
				width: 794px;
				border-right: 1px dotted #EDEFF2;
				box-sizing: border-box;

				.order-msg {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					font-size: 14px;
					color: $fontColor;

					.order-no {
						margin-left: 60px;
					}
				}

				.good-msg {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: 10px;

					.good-content {
						flex: 1;
						display: flex;
						justify-content: flex-start;
						align-items: center;

						.img-box:first-child {
							margin-left: 0;
						}

						.img-box {
							display: flex;
							justify-content: center;
							align-items: center;
							margin-left: 10px;
							width: 88px;
							height: 88px;
							background: #FFFFFF;
							border: 1px solid #EDEFF2;
							border-radius: 15px;
							overflow: hidden;

							img {
								width: 100%;
							}
						}
					}

					.total-box {
						flex-shrink: 0;
						margin-left: 60px;
						text-align: center;

						.num {
							font-size: 14px;
							color: $fontColor;

							span {
								margin: 0 4px;
								font-weight: bold;
							}
						}

						.price {
							margin-top: 4px;
							font-size: 15px;
							font-weight: bold;
							color: #262728;
						}
					}

					.status-box {
						flex-shrink: 0;
						margin-left: 60px;
						text-align: center;

						.status {
							font-size: 14px;
							font-weight: bold;
							color: #F65B13;
						}

						.status-cancel {
							color: #909399;
						}

						.detail-btn {
							margin-top: 4px;
							font-size: 15px;
							text-decoration: underline;
							color: #262728;
							cursor: pointer;
						}
					}
				}
			}

			.right-box {
				flex-shrink: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				width: 163px;

				.count-down {
					margin-bottom: 10px;
					font-size: 14px;
					color: #909399;
				}

				.el-button:last-child {
					margin-bottom: 0;
				}

				.el-button {
					margin-bottom: 10px;
				}

				.el-button--primary {
					width: 103px;
					height: 42px;
					border-radius: 8px;
					font-size: 16px;
				}
				.is-plain {
					margin-left: 0;
					width: 103px;
					height: 42px;
					// background: #F8F8F8;
					// border: 1px solid #C0C4CC;
					border-radius: 8px;
					font-size: 16px;
					// color: $fontColor;
				}
			}
		}

		.el-pagination {
			display: flex;
			justify-content: center;
			align-items: center;

			button,
			button:disabled {
				background-color: rgba(255, 255, 255, 0);
			}

			.el-pager {
				li {
					padding: 0 12px;
					min-width: 28px;
					background-color: rgba(255, 255, 255, 0);
					font-weight: 500;
					font-size: 14px;
				}

				.active {
					background: #FFCC00;
					border-radius: 8px;
					font-weight: bold;
					color: $fontColor;
				}
			}
		}
		.warning-box {
			width: 307px;
			background: #FFFFFF;
			border-radius: 15px;
			margin: 0 auto;
			box-sizing: border-box;
			padding: 20px 29px;
			padding-top: 0;
		
			.title {
				margin: 0 auto;
				text-align: center;
				font-size: 17px;
				font-weight: bold;
				color: #000000;
			}
		
			.btn {
				width: 100%;
				background: #FFCC00;
				line-height: 40px;
				text-align: center;
				color: #262728;
				font-size: 15px;
				font-weight: bold;
				border-radius: 23px;
			}
		
			.warning-list {
				margin: 0 0 30px;
				width: 100%;
				font-size: 13px;
				font-weight: 500;
				color: #606366;
		
				.li {
					margin-bottom: 5px;
				}
			}
		}
	}
</style>
